export default "__VITE_ASSET__BR4YH894__"